<template>
  <div class="pageContent">
    <div class="top-form">
      <el-form
      ref="form"
      inline
      :model="form"
    >
      <el-form-item label="支付状态" prop="pay_status">
        <el-select
          size="small"
          v-model="form.pay_status"
          placeholder="请选择状态"
          @change="onSearch"
        >
          <el-option 
            v-for="(item,index) in items"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
          <el-option 
            label="全部"
            :value="null"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="卡名称" prop="card_name">
        <el-input
          size="small"
          placeholder="名称"
          v-model="form.card_name"
          clearable
          @clear="close('name')"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单号" prop="order_sn">
        <el-input
          size="small"
          placeholder="订单号"
          v-model="form.order_sn"
          clearable
          @clear="close('sn')"
        ></el-input>
      </el-form-item>
      <el-form-item label="操作员工" prop="order_sn">
        <el-select
          size="small"
          v-model="form.emp_id"
          placeholder="请选择员工"
          clearable
          @change="onSearch"
        >
          <el-option v-for="(item,i) in emplist" :key="i" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input
          size="small"
          style="width: 150px"
          placeholder="购买用户手机号"
          v-model="form.mobile"
          clearable
          @clear="close('mobile')"
        ></el-input>
      </el-form-item>
      <el-form-item label="时间筛选" prop="time">
        <el-date-picker
          style="width: 230px"
          v-model="time"
          type="datetimerange"
          size="small"
          range-separator="-"
          value-format="timestamp"
          format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="onSearch"
          >搜索</el-button
        >
        <el-button size="small" @click="reset">重置</el-button>
      </el-form-item>
      </el-form>
    </div>
    
    <div class="stat_box">
      <div class="stat_item">
        <div class="stat_item_title">订单数量</div>
        <div class="stat_item_value">
          {{ statData.order_num||0 }}
          <span>单</span>
        </div>
      </div>
      
      <div class="stat_item2" style="width: 90%;">
        <div class="stat_item_title">金额</div>
        <div class="stat_item_value2">
          <div class="item_value_part">
            <div class="part_name">销售金额</div>
            <div class="part_value" >
              {{ statData.amount || '0.00' }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" style="flex: 4">
            <div class="part_name">平台获得</div>
            
            <div class="part_value" >
              {{ statData.platform_money || '0.00' }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" >
            <div class="part_name">总额度</div>
            <div class="part_value">
              {{ statData.card_amount || '0.00' }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" >
            <div class="part_name">剩余额度</div>
            <div class="part_value">
              {{ statData.remain_card_amount || '0.00' }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" >
            <div class="part_name">使用额度</div>
            <div class="part_value">
              {{ statData.use_amount || '0.00' }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" style="flex: 4">
            <div class="part_name">手续费</div>
            <div class="part_value">
              {{ statData.fee||'0.00' }}
              <span>元</span>
            </div>
          </div>
        </div>
      </div>
     
    </div>
    <div class="table_box">
      <el-table  :data="tableData" style="width: 100%;margin: 20px auto;" border>
        <el-table-column prop="order_sn" fixed align="center" label="订单号" > </el-table-column>
        <el-table-column prop="card_number" align="center" label="卡号" > </el-table-column>
        <el-table-column prop="card_name" align="center" label="卡名"> </el-table-column>
        <el-table-column prop="card_type" align="center" label="卡类型" >
          <template slot-scope="scope">
            <div>{{card_type[scope.row.card_type]}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="card_type" align="center" label="总额度" >
          <template slot-scope="scope">
            <div v-if="scope.row.card_type==1">{{scope.row.card_amount}}元</div>
            <div v-else-if="scope.row.card_type==2">{{scope.row.card_num}}次</div>
            <div v-else>{{scope.row.show_card_duration}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="card_type" label="剩余额度" >
          <template slot-scope="scope">
            <div v-if="scope.row.card_type==1">{{scope.row.remain_card_amount}}元</div>
            <div v-else-if="scope.row.card_type==2">{{scope.row.remain_card_num}}次</div>
            <div v-else>
              <div v-if="scope.row.card_type==3">到期时间</div>
              <div>{{scope.row.show_card_expire}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sale_amount" align="center" label="销售金额(元)" ></el-table-column>
        <el-table-column prop="mobile" align="center" label="购买用户"></el-table-column>
        <el-table-column prop="pay_status" align="center" label="支付状态" >
          <template slot-scope="scope">
            {{ items.find(x=>x.value==scope.row.pay_status).name }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_status" align="center" label="退款状态">
          <template slot-scope="scope">
            {{ refundStatusArr.find(x=>x.value==scope.row.refund_status).name }}
          </template>
        </el-table-column>
        <el-table-column prop="show_paycode" align="center" label="支付方式" >
        </el-table-column>
        <el-table-column prop="create_time" align="center" label="下单时间" >
          <template slot-scope="scope">
            {{ scope.row.create_time | dataFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="payment_time" align="center" label="支付时间" >
        </el-table-column>
        <el-table-column prop="emp_name" align="center" label="操作员工" >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="use_list(scope.row)">使用记录</el-button>
            <el-button type="text" @click="refundShow(scope.row)">订单退款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :hide-on-single-page="total_num <= 10"
        style="width: 95%;margin: 20px auto; "
        layout="prev, pager, next"
        :total="total_num"
        @current-change="current_page"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="退款操作"
      :visible.sync="refundIsShow"
      @close="closeRefund"
      width="700px"
    >
      <el-form label-width="auto">
        <div style="margin-bottom: 10px;">退款单号: {{ refund.order_sn }}</div>
        <div style="margin-bottom: 10px;">退款金额: {{ refundMoney }}</div>
        <el-form-item label="退款原因">
          <el-input
            v-model="refund.refund_desc"
            placeholder="请输入退款原因"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <verificationCodeVue v-model="refund.verification_code" v-if="config.open_refund_platform_order == 1"></verificationCodeVue>
        <!-- <el-form-item
          label="验证码"
          v-if="config.open_refund_platform_order == 1"
        >
          <el-input
            placeholder="请输入"
            v-model="refund.verification_code"
            style="width: 220px;"
          >
            <template slot="append">
              <el-link :disabled="btn_status" @click="getCode" type="primary">
                {{ code_text }}
              </el-link>
            </template>
          </el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button @click="closeRefund">取 消</el-button>
          <el-button type="primary" @click="refundSubmit">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { SendAdminCode,get_safeinfo } from "@/api/set";
import { card_order_list,card_order_count,card_order_refund } from "@/api/platform_card";
import { mapGetters } from "vuex";
import paywayList from "@/utils/payment_code";
import time from "@/utils/time";
import verificationCodeVue from "@Components/verification/verificationCode"
import {employeeList} from '@/api/employee'

export default {
  computed: {
    ...mapGetters(["app_id"])
  },
  data() {
    return {
      form: {
        pay_status: 2
      },
      statData:{},
      emplist:[],
      time:[],
      card_type: ["", "金额", "次数", "时间"],
      paywayList: paywayList,
      source_index: [
        "wx",
        "wxapp",
        "h5",
        "ali",
        "aliapp",
        "pc",
        "hand",
        "pos",
        "ruyi"
      ],
      source_name: [
        "微信",
        "微信小程序",
        "h5",
        "支付宝",
        "支付宝小程序",
        "后台",
        "手持设备",
        "终端机",
        "如意"
      ],
      items: [
        { name: "未支付",value:1 },
        { name: "冻结中",value:3 },
        { name: "支付成功",value:2 },
        { name: "已退款",value:4 }
      ],
      refundStatusArr: [
        { name: "未退款",value:0 },
        { name: "退款中",value:1 },
        { name: "退款完成",value:2 },
        { name: "退款失败",value:3 }
      ],
      tableData: [],
      page: 1,
      refundIsShow: false,
      total_num: 0,
      refundMoney: 0,
      refund:{
        order_sn: '',
        refund_desc: '',
        verification_code: ''
      },
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      config:{}
    };
  },
  mounted() {
    this.getemp()
    this.get_tableData(this.form);
  },
  methods: {
    // 安全設置详情
    async get_detail() {
      try {
        var data = { app_id: this.app_id };
        const res = await get_safeinfo(data);
        if (res.code == 200) {
          this.config = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 管理员发送验证码
    async SendMyCode() {
      try {
        var data = { app_id: this.app_id };
        const res = await SendAdminCode(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.SendMyCode();
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    // 订单退款
    refundShow(row) {
      this.get_detail()
      this.refundMoney = row.sale_amount;
      this.refund.order_sn = row.order_sn;
      this.refundIsShow = true;
    },
    closeRefund() {
      this.refund.order_sn = "";
      this.refund.refund_desc = "";
      this.refund.verification_code = "";
      this.refundIsShow = false;
    },
    refundSubmit() {
      let data = {
        app_id: this.app_id,
        ...this.refund
      };
      this.$confirm("确定要为此订单退款吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var loading = this.$loading({
            lock: true,
            text: "退款中,请耐心等待...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          card_order_refund(data).then((res) => {
            if (res.code == 200) {
              loading.close();
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.refund.order_sn = "";
              this.refund.refund_desc = "";
              this.refund.verification_code = "";
              this.refundIsShow = false;
              this.getData(1);
            } else {
              loading.close();
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {});
    },
    async getdatas(data_val){
      delete data_val.page
      const res = await card_order_count(data_val)
      if(res.code == 200){
        this.statData = res.data
      }
    },
    async getemp(){
      const res = await employeeList({app_id:this.app_id,limit:100})
      if(res.code == 200){
        this.emplist = res.data
      }
    },
    //搜索
    onSearch() {
      if(this.time.length>0){
        this.form.start_time = this.time[0]/1000
        this.form.end_time = this.time[1]/1000
      }
      this.get_tableData(this.form);
    },
    //清空input
    close(val){
      switch (val){
        case 'name':
          this.form.card_name = undefined
          break;
        case 'sn':
          this.form.order_sn = undefined
          break;
        case 'mobile':
          this.form.mobile = undefined
          break;
      }
      this.get_tableData(this.form)
    },
    //使用记录
    use_list(row){
      console.log(row)
      this.$router.push({
        path:'/apply/newVip/13/card/activityCard/card_use_list',
        query:{
          id:row.id
        }
      })
    },
    //重置
    reset() {
      this.time = []
      Object.keys(this.form).forEach(key => {
        delete this.form[key];
      });
      this.get_tableData();
    },
    async get_tableData(data) {
      try {
        let data_val = {
          app_id: this.app_id,
          page: this.page,
          ...data
        };
        const res = await card_order_list(data_val);
        this.tableData = res.data.result;
        console.log(this.paywayList);
        this.tableData.forEach((item, i) => {
          if (item.payment_code) {
            item.show_paycode = this.paywayList.find(
              o => o.id === item.payment_code
            ).name;
          } else {
            item.show_paycode = "";
          }
          if (item.payment_time) {
            item.payment_time = this.timerFunc(item.payment_time);
          } else {
            item.payment_time = "";
          }
          if(item.card_duration){
            item.show_card_duration = time.secondsFormat(item.card_duration)
          }
          if(item.card_expire){
            item.show_card_expire = time.setTime(item.card_expire)
          }
        });
        console.log("2w22", this.tableData);
        this.total_num = res.data.total_num;
        this.getdatas(data_val)
      } catch (e) {
        console.log(e);
      }
    },
    timerFunc(originVal) {
      const dt = new Date(originVal * 1000);
      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");
      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
    current_page(val) {
      this.page = val;
      this.get_tableData();
    },
    info(row) {
      this.$router.push({
        path: "/apply/newVip/13/card/activityCard/set_card",
        query: {
          id: row.id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.pageContent {
  background-color: #f1f2f6;
  border: 20px solid #f1f2f6;
  // padding: 0 20px 10px 20px;
  height: 100%;
  overflow: auto;
  .options {
    line-height: 79px;
  }
  .table_box {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #fff;
  }
  .form_input {
    width: 240px;
  }
  .top-form{
    padding: 20px;
    background-color: #fff;
  }
}
.stat_box {
    // margin-top: 20px;
    display: flex;
    padding: 8px 0;
    justify-content: space-between;
    .stat_item:first-child {
      margin: 0;
    }
    .stat_item {
      width: 9%;
      background: #fff;
      height: 100px;
    }
    .stat_item2 {
      width: 45.5%;
      background: #fff;
      height: 100px;
    }
    .stat_item3 {
      width: 45%;
      background: #fff;
      height: 100px;
    }
    .stat_item_title {
      height: 29px;
      line-height: 29px;
      padding-left: 10px;
      border-bottom: 1px solid #f5f5f5;
    }
    .stat_item_value {
      width: 100%;
      height: 60%;
      padding: 0px 10px;
      // padding-top: 8px;
      font-size: 21px;
      // line-height: 21px;
      color: #666;
      display: flex;
      align-items: center;
      // justify-content: center;
      span {
        font-size: 14px;
      }
    }
    .stat_item_value2 {
      text-align: center;
      line-height: 24px;
      color: #666;
      display: flex;
      .item_value_part {
        flex: 5;
        padding-top: 6px;
        .part_name {
          height: 30px;
          line-height: 30px;
        }
        .part_value {
          font-size: 22px;
          span {
            font-size: 14px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
    .stat_item_value3 {
      color: #666;
      display: flex;
      .item_value_part {
        padding-left: 10px;
        flex: 1;
        padding-top: 7px;
        .part_value {
          font-size: 20px;
          line-height: 26px;
          span {
            font-size: 13px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
    .stat_item_value4 {
      color: #666;
      display: flex;
      text-align: center;
      .item_value_part {
        flex: 1;
        padding-top: 12px;
        .part_title4 {
          font-size: 13px;
          margin-bottom: 5px;
        }
        .part_value {
          font-size: 20px;
          line-height: 26px;
          span {
            font-size: 13px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
  }
</style>
